import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { presetsApi } from '../../api/presets';
import { GQLArgs } from '../../types';

type DeletePresetResponse = { removePreset: { name: string; content: string } };

export const useMutationDeletePreset = (args?: GQLArgs<DeletePresetResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<DeletePresetResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { id: number; name?: string } }) => {
      setLoading(true);
      try {
        await presetsApi.remove(variables.id);
        const shaped: DeletePresetResponse = {
          removePreset: { name: variables.name ?? '', content: '' },
        };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Preset has been removed', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
